import { get } from "../../../services/request";

export const getDashboardData = (userId) => get(`Dashboard/GetDashboardData?userId=${userId}`);
export const getPortfolioDashboard = (userId) =>
    get(userId ? `Dashboard/GetPortfolioDashboard?userId=${userId}` : `Dashboard/GetPortfolioDashboard`);
